import React from 'react';

const ConfirmationIcon = () => {
  return (
<svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.3987 8.77344H15.2985C15.0593 8.77344 14.8317 8.88828 14.691 9.08516L11.0034 14.1945L9.3332 11.8789C9.19245 11.6844 8.96725 11.5672 8.72564 11.5672H7.62546C7.47298 11.5672 7.38384 11.7406 7.47298 11.8648L10.3958 15.9148C10.4649 16.0111 10.5559 16.0896 10.6614 16.1437C10.7668 16.1978 10.8837 16.2261 11.0022 16.2261C11.1208 16.2261 11.2376 16.1978 11.3431 16.1437C11.4485 16.0896 11.5396 16.0111 11.6086 15.9148L16.5489 9.07109C16.6403 8.94688 16.5512 8.77344 16.3987 8.77344Z" fill="#0FB680"/>
<path d="M12.0091 2C6.20566 2 1.5 6.70156 1.5 12.5C1.5 18.2984 6.20566 23 12.0091 23C17.8126 23 22.5183 18.2984 22.5183 12.5C22.5183 6.70156 17.8126 2 12.0091 2ZM12.0091 21.2188C7.19089 21.2188 3.2828 17.3141 3.2828 12.5C3.2828 7.68594 7.19089 3.78125 12.0091 3.78125C16.8274 3.78125 20.7355 7.68594 20.7355 12.5C20.7355 17.3141 16.8274 21.2188 12.0091 21.2188Z" fill="#0FB680"/>
</svg>

  );
};

export default ConfirmationIcon;
 